import {useEffect, useRef, useState} from "react";
import axios from 'axios';
import {useDispatch} from "react-redux";
import Modal from "../../elements/Modal";
import {isJsonString} from "../../../functions/functions";
import {formValid, resetFieldsErrors} from "../../../functions/form";
import {setError} from "../../../slices/error/ErrorSlice";

export default function Kodfito() {
    const dispatch = useDispatch();

    const[kodfitoList, setKodfitoList] = useState([]);
    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);
    const[kodfitoForm, setKodfitoForm] = useState({
        name: '',
        str1: '',
        str2: '',
        str3: ''
    });
    const formRefs = useRef({
        name: useRef(null),
        str1: useRef(null),
        str2: useRef(null),
        str3: useRef(null)
    });
    const[editId, setEditId] = useState(null);
    const[delId, setDelId] = useState(null);
    const[nameDel, setNameDel] = useState(null);

    useEffect(() => {
        getKodfitoList();
    }, []);

    function getKodfitoList() {
        axios.get('/api/kodfito-list-voc')
            .then(res => {
                setKodfitoList(res.data)
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function modalShowToggler() {
        setModalShow(!modalShow);
    }

    function changeHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setKodfitoForm({...kodfitoForm, [fieldName]: value});
    }

    function closeModalKodfito() {
        setModalShow(!modalShow);
        resetKodfitoForm();
        resetFieldsErrors(formRefs.current);
    }

    function resetKodfitoForm() {
        setKodfitoForm({
            name: '',
            str1: '',
            str2: '',
            str3: ''
        })
    }

    function openModalDelHandler(e) {
        setDelId(Number(e.currentTarget.getAttribute('iid')));
        setNameDel(e.currentTarget.previousSibling.previousSibling.previousSibling.previousSibling.previousSibling.innerHTML)
        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setDelId(null);
        setNameDel(null);
    }

    function createHandler() {
        axios.post('/api/kodfito/create', kodfitoForm)
            .then(res => {
                getKodfitoList();
                closeModalKodfito();
            })
            .catch((e) => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function getKodfitoHandler(e) {
        const id = e.currentTarget.getAttribute('iid');
        setEditId(id);

        axios.get(`/api/kodfito/${id}`)
            .then(res => {
                setKodfitoForm(Object.assign(kodfitoForm, res.data));
                modalShowToggler();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function editHandler() {
        axios.post(`/api/kodfito/${editId}/edit`, kodfitoForm)
            .then(res => {
                closeModalKodfito();
                getKodfitoList();
            })
            .catch(e => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function delHandler() {
        axios.delete(`/api/kodfito/${delId}/del`)
            .then(res => {
                closeModalDelHandler();
                getKodfitoList();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = kodfitoList.map(item =>
        <tr key={item.id}>
            <td style={{width: 95}}>{item.id}</td>
            <td>{item.name}</td>
            <td>{item.str1}</td>
            <td>{item.str2}</td>
            <td>{item.str3}</td>
            <td iid={item.id} onClick={getKodfitoHandler} style={{width: 95}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                     className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path
                        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td iid={item.id} onClick={openModalDelHandler} style={{width: 95}}>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return (
        <>
            <Modal
                header={editId ? 'Редактирование' : 'Добавить Клиента'}
                show={modalShow}
                closeHandler={closeModalKodfito}
            >
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Наименование</label>
                    <div className="col-sm-9">
                        <input type="text" name='name' className="form-control" id="name" ref={formRefs.current.name}
                               onChange={changeHandler} value={kodfitoForm.name}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Строка 1</label>
                    <div className="col-sm-9">
                        <input type="text" name='str1' className="form-control" ref={formRefs.current.str1}
                               onChange={changeHandler} value={kodfitoForm.str1}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Строка 2</label>
                    <div className="col-sm-9">
                        <input type="text" name='str2' className="form-control" ref={formRefs.current.str2}
                               onChange={changeHandler} value={kodfitoForm.str2}
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="inputLogin" className="col-sm-3 col-form-label">Строка 3</label>
                    <div className="col-sm-9">
                        <input type="text" name='str3' className="form-control" ref={formRefs.current.str3}
                               onChange={changeHandler} value={kodfitoForm.str3}
                        />
                    </div>
                </div>


                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={editId ? editHandler : createHandler}
                           value="Сохранить"/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalKodfito}
                           value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить экспортера'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{nameDel}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={delHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Коды</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalShowToggler} value='Добавить'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Наименование</th>
                    <th scope="col">Строка1</th>
                    <th scope="col">Строка2</th>
                    <th scope="col">Строка3</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        </>
    )
}